import styled from 'styled-components';
import { CEB_COLOR } from 'app-constants/CEB_COLOR';

export const StyledLinkButton = styled.button`
  margin-left: 25px;
  color: ${CEB_COLOR('NICE_BLUE')};
  font-size: 13px;
  font-weight: bold;
  font-family: 'Zilla Slab', serif;
`;
